<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>

export default {
  name: 'App',
	data () {
		return {
      pathArr:[
        {pcPath: '/login',mPath:'/mobileLogin'}, // 登录页
        {pcPath: '/register',mPath:'/mobileRegister'}, // 注册页
        {pcPath: '/personalHome',mPath:'/mobilePersonalCenter'}, // 个人首页
        {pcPath: '/personalInfo',mPath:'/mobilePersonalInfo'}, // 个人信息
        {pcPath: '/personalSafe',mPath:'/settings'}, // 账号安全/设置
        {pcPath: '/address',mPath:'/addressManage'}, // 收货信息/地址管理
        // 积分-----开发中
        {pcPath: '/myfootprint',mPath:'/mobMyFootPrint'}, // 我的足迹
        {pcPath: '/gwc',mPath:'/goodsShop'}, // 我的购物车
        {pcPath: '/personalOrder',mPath:'/mOrderList'}, // 我的订单
        {pcPath: '/purchased',mPath:'/purchasedRescource'}, // 我的已购
        {pcPath: '/exchange',mPath:'/exchangeBag'}, // 兑换增值服务包
        {pcPath: '/personalValSerPack',mPath:'/servicePackageList'}, // 我的增值服务包
        {pcPath: '/personalanswer',mPath:'/answerQuestionList'}, // 答题记录
        {pcPath: '/personalReadingNotes',mPath:'/mMyRead'}, // 我的阅读
        {pcPath: '/personalcollect',mPath:'/mMyFavourite'}, // 我的收藏
        {pcPath: '/class/invitationCode',mPath:'/class/mInvitationCode'}, // 我的收藏
        // 我的读者圈------开发中
      ]
		}
	},
  watch:{
    $route:{
      handler: function(to, from) {
        console.log('路径2333',to.fullPath)
        console.log('路径23334',to)
        let thePath = to.path
        let fullPath = to.fullPath
        console.log('路径23335',thePath)
        for(let i=0;i<this.pathArr.length;i++){
          if(thePath == this.pathArr[i].pcPath){
              // alert(2)
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              // alert(1)
              let mPath = fullPath.replace(this.pathArr[i].pcPath, this.pathArr[i].mPath)
              if(thePath == '/personalOrder'){
                window.location.href = process.env.SSO_WEB_URL + mPath + '?index=0'
              }else{
                window.location.href = process.env.SSO_WEB_URL + mPath
              }
              console.log('路径2333m',mPath)
            } else {
              return;
            }
            // return mPath;
          }
          if(thePath == this.pathArr[i].mPath){
              // alert(3)
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              return;
            } else {
              // alert(2)
              let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
              if(thePath == '/mOrderList'){
              window.location.href = process.env.SSO_WEB_URL + '/personalOrder'
              }else{
              window.location.href = process.env.SSO_WEB_URL + pcPath
              }
              console.log('路径2333pc',pcPath)
            }
            // return mPath;
          }
          // break
        }
      

      },
    }
  },
  // mounted(){
  //     var li_second = document.querySelectorAll('.li_second')
  //     console.log('li_second='+li_second)
  // },
  methods:{
    goTop(){
      document.body.scrollTop = 0,
      document.documentElement.scrollTop = 0
    }
  },
  mounted () {
      this.goTop()
  }
}
</script>

<style scoped>
*{
  background: #f8f8f8;
}
/* #app{
  min-width: 1200px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue